
/**
 * 剪切图片
 * @param {string} base64Str 
 * @param {number} offsetLeftPercent 
 * @param {number} offsetTopPercent 
 * @param {number} widthPercent 
 * @param {number} heightPercent 
 * @returns 
 */
export function clipImage(base64Str, offsetLeftPercent, offsetTopPercent, widthPercent, heightPercent) {
    return new Promise((res) => {
      const img = new Image();
      img.src = base64Str;
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      const createW = document.createAttribute('width');
      const createH = document.createAttribute('height');
  
      img.onload = () => {
        createW.nodeValue = `${img.naturalWidth * widthPercent}px`;
        createH.nodeValue = `${img.naturalHeight * heightPercent}px`;
  
        canvas.setAttributeNode(createW);
        canvas.setAttributeNode(createH);
  
        ctx?.drawImage(
          img,
          img.naturalWidth * offsetLeftPercent,
          img.naturalHeight * offsetTopPercent,
          img.naturalWidth * widthPercent,
          img.naturalHeight * heightPercent,
          0,
          0,
          img.naturalWidth * widthPercent,
          img.naturalHeight * heightPercent
        );
        res(canvas.toDataURL('image/png'));
      };
    });
  }